import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { SHOPPING_CATEGORY_COLLECTIONS } from '../../../../constants';
import ProductListMobileFilter from './filter';
import ShoppingSearch from '../../search';
import { SVGs } from '../../../common/fa_icons';
import i18nMessages from '../__i18n__';
import { injectIntl } from 'react-intl';
import ProductListHeroImage from '../hero_image';
import ProductListFilterSortWrapper from '../filter_sort_wrapper';
import ShoppingBreadcrumbsBar from '../../breadcrumbs_bar';
import ProductListHeroContent from './../hero_content';
import classNames from 'classnames';
import {get, find, isEmpty} from 'lodash';
import { nodeAttrs, smoothScrollTo } from '../../../../utils/dom';
import Link from 'react-router/lib/Link';
import RosettaFormattedMessage from '../../../common/rosetta_formatted_message';

const MIN_FILTER_BAR_TOP = 70;

export class ProductListMobileNavigation extends Component {
  state = { showFilters: false };

  toggleFilterVisibility = () => {
    //close the filter & sort drop-down if it is open
    if (!this.props.filterSortHidden) {
      this.props.toggleFilterAndSort();
    }

    const { top } = nodeAttrs(this._filterBar);
    if (top >= MIN_FILTER_BAR_TOP) {
      smoothScrollTo(this._searchBar);
    }

    this.setState({
      showFilters: !this.state.showFilters
    });
  };

  handleFilterSortClick = () => {
    if (this.state.showFilters) {
      this.setState({ showFilters: false });
    }

    const { top } = nodeAttrs(this._filterBar);

    /*
     *Mobile only: scroll to the nav up so user can see it.
     *Do not scroll if closing the filter sort wrapper
     */
    if (this.props.filterSortHidden && top > MIN_FILTER_BAR_TOP) {
      smoothScrollTo(this._filterBar);
    /*
     * When the ProductListFilterSortWrapper is open, scrolling to
     * this._filterBar hides the filter bar behind the global nav
     */
    } else {
      smoothScrollTo(this._searchBar);
    }

    this.props.toggleFilterAndSort();
  };

  /*
   *On mobile, the sale checkbox is included in the filter sort wrapper,
   *so we want to wait to update it until the update button is clicked.
   */
  handleFilterSaleClick = (event) => {
    this.props.handleSaleToggle(event, true);
  };

  render() {
    const { showFilters } = this.state;

    const { intl, shoppingNavigationItems: { categories, subcategories,
      classes, pageTitle }, on_sale, sort, categoryFilter,
    subcategoryFilter, classFilter, productList: { campaignBrandingImage, categoryType,
      resultCount, heroImage, logoImage, openerImages, isBrandOrRetailerPage, breadcrumbs,
      isShoppingHome, description }, selectedPriceRange, handleFilterAndSortUpdate,
    handleFilterAndSortClear, handleColorFilter, handlePriceFilter, handleSort,
    colorFilters, filterSortHidden } = this.props;
    const messages = i18nMessages();

    const { query: { q } } = this.context.location;
    const hasQueryParam = q && q.length > 0;

    const activeTopLevelCategory = find(categories, 'is_active');

    const filterSectionClasses = classNames(
      'filter-section',
      { 'is-visible': showFilters }
    );

    let firstDropDownFilter;
    if (isBrandOrRetailerPage) {
      firstDropDownFilter = (
        <ProductListMobileFilter
          label={intl.formatMessage(messages.department)}
          filterLabel="department"
          filter={categoryFilter}
          dropdownItems={categories}
          handleFilter={this.props.handleFilter}
        />
      );
    }

    let subcategoryMobileFilter;
    if (subcategories.length > 0 && categoryType !== SHOPPING_CATEGORY_COLLECTIONS) {
      subcategoryMobileFilter = (
        <ProductListMobileFilter
          label={intl.formatMessage(messages.category)}
          filterLabel="category"
          filter={subcategoryFilter}
          dropdownItems={subcategories}
          handleFilter={this.props.handleFilter}
        />
      );
    }

    let classMobileFilter;
    if (subcategoryFilter && classes.length > 0) {
      classMobileFilter = (
        <ProductListMobileFilter
          label={intl.formatMessage(messages.type)}
          filter={classFilter}
          dropdownItems={classes}
          handleFilter={this.props.handleFilter}
        />
      );
    }

    let heroImageHtml;
    if (heroImage || !isEmpty(openerImages)) {
      heroImageHtml = (
        <ProductListHeroImage
          heroImage={heroImage}
          logoImage={logoImage}
          openerImages={openerImages}
          pageTitle={pageTitle}
          categoryType={categoryType}
          brandingBanner={campaignBrandingImage}
          isShoppingHome={isShoppingHome}
        />
      );
    } else if (!hasQueryParam) {
      heroImageHtml = (
        <div className="hero-wrapper">
          <ProductListHeroContent
            pageTitle={pageTitle}
            categoryType={categoryType}
          />
        </div>
      );
    }

    let subtitle;
    if (
      description
      && description.length > 0
      && (categoryType === SHOPPING_CATEGORY_COLLECTIONS || isBrandOrRetailerPage)
    ) {
      subtitle = (
        <div className="subtitle">
          <div className="subtitle-inner">
            <h2 dangerouslySetInnerHTML={{ __html: description }} />
          </div>
        </div>
      );
    }

    let viewAllCollectionsLink;
    if ((categoryType === SHOPPING_CATEGORY_COLLECTIONS)) {
      viewAllCollectionsLink = (
        <Link className="all-collections-link" to="/en-us/shop/collections">
          <RosettaFormattedMessage parentFilename={__filename}
            id="collections"
            description="View All Collections Link in filter bar"
            defaultMessage="Collections"
          />
          <span className="fa fa-chevron-right"
            dangerouslySetInnerHTML={{ __html: SVGs['chevron-right'] }}
          />
        </Link>
      );
    }

    return (
      <div className="product-list-navigation">
        {!isShoppingHome && <ShoppingBreadcrumbsBar breadcrumbs={breadcrumbs} />}
        {!isShoppingHome && heroImageHtml}
        {subtitle}
        <div className="search-nav" ref={node => this._searchBar = node}>
          <ShoppingSearch resultCount={resultCount} searchTerm={q} />
        </div>
        <div className={classNames('filter-bar', { 'active': !filterSortHidden })}
          ref={node => this._filterBar = node}
        >
          {viewAllCollectionsLink}
          {
            categoryType !== SHOPPING_CATEGORY_COLLECTIONS &&
            <div className={classNames('browse-label', { 'active': showFilters })} onClick={this.toggleFilterVisibility}>
              <span className="text" dangerouslySetInnerHTML={{ __html: 'Browse By' }} />
              <span className="fa fa-chevron-down"
                dangerouslySetInnerHTML={{ __html: SVGs['chevron-down'] }}
              />
            </div>
          }
          <ProductListFilterSortWrapper
            handleFilterSortClick={this.handleFilterSortClick}
            filterSortHidden={filterSortHidden}
            handleFilterAndSortUpdate={handleFilterAndSortUpdate}
            handleFilterAndSortClear={handleFilterAndSortClear}
            handleColorFilter={handleColorFilter}
            handlePriceFilter={handlePriceFilter}
            handleSort={handleSort}
            shoppingNavigationItems={this.props.shoppingNavigationItems}
            colorFilters={colorFilters}
            on_sale={on_sale}
            handleFilterSaleClick={this.handleFilterSaleClick}
            selectedPriceRange={selectedPriceRange}
            sort={sort}
          />
        </div>
        <div className={filterSectionClasses}>
          {
            !isBrandOrRetailerPage &&
            <ProductListMobileFilter
              label={intl.formatMessage(messages.department)}
              dropdownItems={categories}
              activeTopLevelCategoryName={get(activeTopLevelCategory, 'name')}
              handleFilter={this.props.handleFilter}
            />
          }
          {firstDropDownFilter}
          {subcategoryMobileFilter}
          {classMobileFilter}
        </div>
      </div>
    );
  }
}

ProductListMobileNavigation.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }),
  api: PropTypes.object.isRequired,
  productList: PropTypes.shape({
    categoryType: PropTypes.string,
    heroImage: PropTypes.string,
    logoImage: PropTypes.string,
    campaignBrandingImage: PropTypes.string,
    breadcrumbs: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string
      }).isRequired
    ),
    resultCount: PropTypes.number
  }).isRequired,
  shoppingNavigationItems: PropTypes.shape({
    categories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      is_active: PropTypes.bool,
      name: PropTypes.string
    })),
    subcategories: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      path: PropTypes.string,
      name: PropTypes.string
    })),
    colors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }))
  }).isRequired,
  sort: PropTypes.string.isRequired,
  on_sale: PropTypes.string,
  categoryFilter: PropTypes.string,
  subcategoryFilter: PropTypes.string,
  classFilter: PropTypes.string,
  handleFilter: PropTypes.func,
  handleSort: PropTypes.func,
  handlePriceFilter: PropTypes.func,
  imageMap: PropTypes.object,
  selectedPriceRange: PropTypes.object,
  handleFilterAndSortUpdate: PropTypes.func.isRequired,
  handleFilterAndSortClear: PropTypes.func.isRequired,
  handleColorFilter: PropTypes.func.isRequired,
  handleSaleToggle: PropTypes.func.isRequired,
  colorFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  filterSortHidden: PropTypes.bool.isRequired,
  toggleFilterAndSort: PropTypes.func.isRequired
};

ProductListMobileNavigation.contextTypes = {
  location: PropTypes.object.isRequired,
  cookies: PropTypes.object
};

export default injectIntl(ProductListMobileNavigation);
